import { PMPagination } from "../../utils/PMPagination";
import { Popup } from "../../utils/Div";
import { CasePriorityStatus, CaseStatus } from "./utils";
import {
  InitialsTag,
  StringLimit,
  dateToString,
  searchFieldsByName,
} from "../../Utils";
import {
  CalendarIcon,
  MapPinIcon,
  WrenchIcon,
} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

export const CasesTableV2 = (props) => {
  const {
    itemState,
    onPageChange,
    itemsCount,
    totalCount,
    currentCount,
    page,
    perPage,
  } = props;
  const { data, isLoading } = itemState;

  const lastItemWithDescription = (item) => {
    // Search items inside "item" that matches module === "description"
    if (item?.items?.length > 0) {
      const descriptionItems = item?.items?.filter(
        (item) => item?.description?.length > 0
      );
      return descriptionItems[0];
    } else if (item?.last_item) {
      return item?.last_item;
    }
  };

  const FieldOrCustomerAddress = ({ item }) => {
    if (
      item?.customer?.postal_address &&
      item?.customer?.postal_address?.address !== "null"
    ) {
      return item?.customer?.postal_address?.displayTitle;
    }
    if (item?.fields) {
      const address = searchFieldsByName(item, "address")?.value;

      if (address) {
        const address2 = searchFieldsByName(item, "address2")?.value;
        const postal = searchFieldsByName(item, "postal")?.value;
        const place = searchFieldsByName(item, "place")?.value;

        // find fields

        return `${address} ${
          address2 ? ", " + address2 : ""
        }, ${postal} ${place}`;
      }
    }

    return "Mangler";
  };

  return (
    <>
      <PMPagination
        disabled={isLoading}
        onPageChange={onPageChange}
        page={page}
        perPage={perPage}
        rowsCount={itemsCount}
        totalCount={totalCount}
        currentCount={currentCount}
        showCount={true}
        showPages={true}
        showNextPrev={true}
      />

      {data && (
        <div className="overflow-hidden">
          <ul role="list" className="divide-y divide-gray-200">
            {data?.map((caseItem) => (
              <li
                className="mt-2 bg-white rounded-xl shadow-sm hover:bg-gray-200"
                key={caseItem.id}
              >
                <Link to={"/dashboard/cases/" + caseItem.id}>
                  <div className="px-4 py-4 sm:px-6">
                    <div className="flex flex-col sm:grid grid-cols-5 items-left sm:items-center justify-between">
                      <p className="flex flex-col truncate text-sm font-medium">
                        <span className="text-blue-400">
                          {caseItem?.case_number}
                        </span>
                        <span>
                          {caseItem?.customer?.id
                            ? caseItem?.customer?.displayTitle
                            : caseItem?.fields
                            ? searchFieldsByName(caseItem, "name")?.value
                            : "--"}
                        </span>
                      </p>

                      <div className="flex flex-col ml-2 col-span-2 col-start-2 flex-shrink-0   text-left">
                        <p className="px-2 py-2 text-xs italic">
                          <StringLimit
                            text={
                              caseItem?.title
                                ? caseItem?.title
                                : "Mangler tittel"
                            }
                            limit={50}
                          />
                        </p>
                        {lastItemWithDescription(caseItem)?.id &&
                          lastItemWithDescription(caseItem)?.description
                            .length > 1 && (
                            <p className="px-2 py-2 bg-blue-200 rounded-md text-xs">
                              <StringLimit
                                text={
                                  lastItemWithDescription(caseItem)?.description
                                }
                                limit={50}
                              />
                            </p>
                          )}

                        {/* <div className="mt-5">
                          <ProjectTitle project={caseItem?.project} />
                          <ReportTitle report={caseItem?.report} />
                          <ServiceAgreementTitle
                            serviceAgreement={caseItem?.service_agreement}
                          />
                          <OrderTitle order={caseItem?.order} />
                        </div> */}
                      </div>

                      <div
                        id="dateAndStatus"
                        className="flex flex-col-reverse sm:flex-row col-span-2 w-full sm:items-center justify-end"
                      >
                        <div className="flex flex-col  mt-2 sm:mt-0">
                          <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                            <CalendarIcon
                              className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400"
                              aria-hidden="true"
                            />
                            <p>
                              Opprettet{": "}
                              <time dateTime={caseItem.created_at}>
                                {dateToString(caseItem?.created_at)}
                              </time>
                            </p>
                          </div>

                          <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                            <CalendarIcon
                              className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400"
                              aria-hidden="true"
                            />
                            <p>
                              Oppdatert{": "}
                              <time dateTime={caseItem.updated_at}>
                                {dateToString(caseItem?.updated_at)}
                              </time>
                            </p>
                          </div>
                        </div>
                        <div className="ml-2 flex flex-shrink-0 right-0 mt-5 sm:mt-0">
                          <p className="flex flex-col gap-3">
                            <CaseStatus caseItem={caseItem} />
                            <CasePriorityStatus priority={caseItem?.priority} />
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 sm:flex sm:justify-between">
                      <div className="sm:flex">
                        <p className="flex items-center text-sm text-gray-500 sm:mr-6">
                          <Popup content={caseItem?.note} textSize="md">
                            <InitialsTag name={caseItem?.user_assigned?.name} />
                          </Popup>
                        </p>
                        <p className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                          <WrenchIcon
                            className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400"
                            aria-hidden="true"
                          />
                          {caseItem.case_type?.title}
                        </p>
                        <p className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-2">
                          <MapPinIcon
                            className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400"
                            aria-hidden="true"
                          />
                          <FieldOrCustomerAddress item={caseItem} />{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}

      <PMPagination
        disabled={isLoading}
        onPageChange={onPageChange}
        page={page}
        perPage={perPage}
        rowsCount={itemsCount}
        totalCount={totalCount}
        currentCount={currentCount}
        showCount={true}
        showPages={true}
        showNextPrev={true}
      />
    </>
  );
};

CasesTableV2.defaultProps = {
  page: 1,
  itemState: [],
  itemsCount: 0,
  selectedItems: [],
  sort: "desc",
  sortBy: "createdAt",
};
